/**
 * @providesModule CurrencyAPIManager
 * API calls specific to v1/user-currency
 */

import {CurrencyCode} from 'INTL';
import NetClient from 'NetClient';
import RESTStore from 'RESTStore';
import {
  NativeModules,
} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

type UserCurrencyResponse = {
  base_currency: CurrencyCode
}

class CurrencyAPIManager {

  /**
   * Calls GET v1/user-currency
   * @param canUseCache whether we can use the cached response or force an API call.
   * @returns 3-letter ISO currency code
   */
  getUserCurrency(canUseCache: boolean): Promise<CurrencyCode> {
    return new Promise((resolve: (value: CurrencyCode) => void, reject: (reason?: any) => void) => {
      const getResponse = canUseCache ? RESTStore.getAnyResponse : RESTStore.getServerResponse;
      getResponse.bind(RESTStore)('user-currency', null, SKZAPIManager.OnError.failSilently, (response: UserCurrencyResponse, error: Error | null) => {
        if (error || !response) {
          reject(error);
        } else {
          const currency = response.base_currency;
          if (currency) {
            resolve(currency);
          } else {
            reject('Empty or invalid response body for v1/user-currency');
          }
        }
      });
    });
  }

  /**
   * Calls POST v1/user-currency
   * @param currency 3-letter ISO currency code
   * @returns should return same currency code passed as parameter if call is successful
   */
  postUserCurrency(currency: CurrencyCode): Promise<CurrencyCode> {
    return new Promise((resolve: (value: CurrencyCode) => void, reject: (reason?: any) => void) => {
      const params = {
        base_currency: currency,
      };
      NetClient.postURL('user-currency', params, SKZAPIManager.OnError.failSilently, (error: any, _response: any) => {
        if (!error) {
          resolve(currency);
        } else {
          reject(error);
        }
      });
    });
  }
}

export default new CurrencyAPIManager();
